export enum SaveReminderCookieValues {
  SHOW_REMINDER = '1',
  HIDE_REMINDER = '0',
}

export const SAVE_REMINDER_COOKIE_KEY = 'pmwsdr';
